export default "__VITE_ASSET__XVRJAXuH__"